<rl-titulo>Estadísticas</rl-titulo>

<cui-section-headline>Resumen General</cui-section-headline>
<tabla-kpi [evaluacionTipo]="tipoInstrumento"></tabla-kpi>
<br />
<cui-section-headline>Gráficos por Asignatura</cui-section-headline>
<estadisticas-simple [evaluacionTipo]="tipoInstrumento"></estadisticas-simple>
